import React from "react";
import "../Style/Gallery.css";
import ga1 from "../Assets/Gallery/ga1.png";
import ga2 from "../Assets/Gallery/ga2.png";
import ga3 from "../Assets/Gallery/ga3.png";
import ga4 from "../Assets/Gallery/ga4.png";
import ga5 from "../Assets/Gallery/ga5.png";
import ga6 from "../Assets/Gallery/ga6.png";
import ga7 from "../Assets/Gallery/ga7.png";
import ga8 from "../Assets/Gallery/ga8.png";
import ga9 from "../Assets/Gallery/ga9.png";
import ga10 from "../Assets/Gallery/g10.png";
import { FaYoutube } from "react-icons/fa";
import { useAppointment } from "./AppointmentContext.js";
import BookAppointment from "./BookAppointment.js";
import { useAuth } from "./UserContext.js";
import EventCaraousel from "./EventCaraousel.js";
import EventImage from "./EventImage.js";
const Gallery = () => {
  const { options, covertDriveLinkToImage, convertGoogleDriveLinkToIframe } =
    useAuth();
  const { appointmentData, handleAppointment } = useAppointment();
  const isMobile = window.innerWidth <= 768;
  const hSkin = [
    { name: "Warts & Moles", imageUrl: ga2 },
    { name: "Acnes, Pimples", imageUrl: ga3 },
    { name: "All types of Tinea", imageUrl: ga4 },
    { name: "Hair Fall", imageUrl: ga5 },
    { name: "Alopecia", imageUrl: ga6 },
    { name: "Psoriasis", imageUrl: ga7 },
  ];
  console.log("Optiuon Galler", options.event);
  console.log("Optiuon Galler 11", options);
  return (
    <div className="gallery-container">
      <h1
        className="our-treatments-h1"
        style={{ fontSize: isMobile ? "30px" : "", marginTop: "0px" }}
      >
        Welcome to Our Healing Gallery
      </h1>
      <div
        style={{
          fontSize: "22px",
          color: "var(--primary-color)",
          textAlign: "center",
          margin: "20px 0px",
        }}
      >
        <b>Our Patients' Stories: Healing with Homeopathy</b>
      </div>
      <div className="gal-para-div">
        <p className="treat-para" style={{ textAlign: "center" }}>
          At{" "}
          <b style={{ color: "var(--primary-color)" }}>
            Homeopathy Healthcare and Research Center
          </b>
          , we are passionate about restoring balance, vitality, and wellness
          through homeopathy. Our gallery is a visual representation of our
          commitment to holistic healing. Here, we share inspiring moments from
          our clinic, patient success stories, the natural remedies we use, and
          the peaceful environment where our patients begin their healing
          journey.
        </p>
        <p
          className="treat-para"
          style={{ textAlign: "center", marginTop: "10px" }}
        >
          Take a moment to browse through the images and discover how homeopathy
          can be a transformative experience for you and your family. We hope
          these pictures inspire you to take the first step toward a healthier,
          more vibrant life.
        </p>
      </div>
      <div className="gal-sec-1">
        <div className="gal-sec-1-1">
          <h1>Our Serene Healing Environment :</h1>
          <p className="treat-para">
            Our clinic is thoughtfully designed to offer a calming and nurturing
            space for healing. From the moment you walk in, you’ll experience an
            atmosphere of tranquility and comfort, providing the perfect setting
            to begin your journey to better health.
          </p>
          <ul className="gal-sec-1-ul">
            <li>
              A welcoming space where every patient is greeted with warmth and
              care. Our reception area is designed to make you feel at ease from
              the moment you arrive.
            </li>
            <li>
              Private, peaceful consultation rooms where you’ll have one-on-one
              sessions with our experienced homeopaths. Here, we listen,
              understand, and create personalized treatment plans tailored to
              your needs.
            </li>
            <li>
              Our natural healing spaces are designed to promote relaxation and
              peace. Whether you’re receiving treatment or simply visiting, the
              soothing atmosphere will help you feel calm and balanced.
            </li>
          </ul>
        </div>
        <div className="gal-sec-1-img">
          <img src={ga1} />
        </div>
      </div>
      <div className="gal-sec-2">
        <h1>Patient Success Stories: Real Healing, Real Results</h1>
        <p className="treat-para">
          The heart of our practice lies in the healing stories of our patients.
          These transformations are a testament to the power of individualized,
          natural treatments. Homeopathy helps address the root causes of
          illness, restoring harmony to the body and mind.
        </p>
        <p className="treat-para">
          Take a look at some of the success stories from our patients who have
          experienced life-changing improvements in their health:
        </p>
      </div>
      <h1
        style={{ textAlign: "center", marginTop: "70px", marginBottom: "40px" }}
      >
        Events
      </h1>
      <div className="gal-sec-31">
        <div className="gal-sec-2-content-2">
           <EventCaraousel/>
           <EventImage/>
        </div>
      </div>
      <h1
        style={{ textAlign: "center", marginTop: "70px", marginBottom: "40px" }}
      >
        Homeopathy For Skin
      </h1>
      <div className="gal-sec-3">
        <div className="gal-sec-2-content">
          {hSkin.map((skin) => (
            <div className="gal-sec-2-1">
              <p className="gal-sec-2-p1">{skin.name}</p>
              <div className="gal-sec-img">
                <img src={skin.imageUrl} />
              </div>
              <div className="gal-content-h3">
                <h3>Before</h3>
                <h3>After</h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="gal-sec-4">
        <h1 className="gal-sec-4-h1">Our Healing Videos</h1>
        <div className="gal-sec-4-youtube">
          <div className="gal-sec-4-youtube-1">
            <FaYoutube size={90} color="red" />
          </div>
          <div className="gal-sec-4-youtube-1">
            <FaYoutube size={90} color="red" />
          </div>
          <div className="gal-sec-4-youtube-1">
            <FaYoutube size={90} color="red" />
          </div>
          <div className="gal-sec-4-youtube-1">
            <FaYoutube size={90} color="red" />
          </div>
          <div className="gal-sec-4-youtube-1">
            <FaYoutube size={90} color="red" />
          </div>
          <div className="gal-sec-4-youtube-1">
            <FaYoutube size={90} color="red" />
          </div>
        </div>
      </div>

      <div className="gal-sec-5">
        <h1
          className="gal-sec-4-h1"
          style={{ fontSize: isMobile ? "33px" : "", marginBottom: "0px" }}
        >
          Natural Remedies in Action: The Power of Homeopathy
        </h1>
        <div className="gal-para-div" style={{ marginTop: "20px" }}>
          <p
            className="treat-para"
            style={{ textAlign: "center", marginTop: "0px" }}
          >
            At{" "}
            <b style={{ color: "var(--primary-color)" }}>
              Homeopathy Healthcare and Research Center
            </b>
            , we specialize in natural remedies that are carefully crafted to
            stimulate your body’s own healing processes. Homeopathy focuses on
            using highly diluted substances from nature to treat a wide range of
            health conditions, offering a holistic and gentle approach to
            wellness.
          </p>
          <p
            className="treat-para"
            style={{ textAlign: "center", marginTop: "10px" }}
          >
            Explore the natural remedies we offer and how they work to restore
            balance and vitality:
          </p>
        </div>
      </div>
      <div className="gal-sec-6">
        <div className="gal-sec-6-content">
          <div>
            <div>
              <img src={ga8} />
            </div>
            <h1
              style={{
                textAlign: "center",
                marginTop: "20px",
                marginBottom: "15px",
              }}
            >
              Homeopathic Remedy Bottles
            </h1>
            <p
              className="treat-para"
              style={{ textAlign: "center", marginTop: "0px" }}
            >
              A selection of the homeopathic remedies we use, each one carefully
              prepared to support the body’s natural healing ability. Our
              remedies are personalized based on your unique symptoms and
              constitution.
            </p>
          </div>
          <div>
            <div>
              <img src={ga9} />
            </div>
            <h1
              style={{
                textAlign: "center",
                marginTop: "20px",
                marginBottom: "15px",
              }}
            >
              Homeopathic Remedy Bottles
            </h1>
            <p
              className="treat-para"
              style={{ textAlign: "center", marginTop: "0px" }}
            >
              A selection of the homeopathic remedies we use, each one carefully
              prepared to support the body’s natural healing ability. Our
              remedies are personalized based on your unique symptoms and
              constitution.
            </p>
          </div>
          <div>
            <div>
              <img src={ga10} />
            </div>
            <h1
              style={{
                textAlign: "center",
                marginTop: "20px",
                marginBottom: "15px",
              }}
            >
              Homeopathic Remedy Bottles
            </h1>
            <p
              className="treat-para"
              style={{ textAlign: "center", marginTop: "0px" }}
            >
              A selection of the homeopathic remedies we use, each one carefully
              prepared to support the body’s natural healing ability. Our
              remedies are personalized based on your unique symptoms and
              constitution.
            </p>
          </div>
        </div>
      </div>

      <div className="gal-sec-7">
        <h1
          style={{
            textAlign: "center",
            marginTop: "20px",
            marginBottom: "15px",
          }}
        >
          Holistic Wellness Workshops and Events
        </h1>
        <p
          className="treat-para"
          style={{ textAlign: "center", marginTop: "10px" }}
        >
          At{" "}
          <b style={{ color: "var(--primary-color)" }}>
            Homeopathy Healthcare and Research Center
          </b>
          , we believe in empowering our patients with knowledge. We host
          regular wellness workshops and events to share tips on how to maintain
          long-term health and healing through diet, lifestyle, and natural
          therapies. Our goal is to help you not only feel better but also take
          charge of your health in a holistic way.
        </p>
      </div>

      <div className="gal-sec-7">
        <h1
          style={{
            textAlign: "center",
            marginTop: "20px",
            marginBottom: "15px",
          }}
        >
          Join Us on Your Healing Journey
        </h1>
        <p
          className="treat-para"
          style={{ textAlign: "center", marginTop: "10px" }}
        >
          We invite you to explore our gallery and see for yourself the healing
          power of homeopathy. If you’re ready to begin your own journey toward
          better health, we’re here to guide you every step of the way. Whether
          you’re looking for relief from a chronic condition or seeking to
          enhance your overall wellness, homeopathy offers a safe, natural
          solution.
        </p>
      </div>

      <div className="gal-sec-8">
        <div>
          <b
            style={{
              color: "var(--primary-color",
              textAlign: "center",
              fontSize: "20px",
            }}
          >
            Book your consultation today and take the first step toward a
            healthier, more vibrant life with homeopathy.
          </b>
        </div>
        <button className="treat-btn" onClick={handleAppointment}>
          BOOK APPOINTMENT
        </button>
      </div>
      {appointmentData && (
        <div className="popup-overlay" onClick={handleAppointment}>
          <BookAppointment handleAppointment={handleAppointment} />
        </div>
      )}
    </div>
  );
};

export default Gallery;
